<template>
  <!-- MODALE SUPPRESSION -->
  <b-modal
    title-class="modal__title"
    v-if="poste"
    id="modal-delete-poste-livraison"
    size="md"
    title="Supprimer le poste de livraison"
    @ok="deletePosteLivraison"
  >
    <p class="mt-3 modal-delete__text">
      Souhaitez-vous supprimer le poste de livraison {{ poste.id }} ?
    </p>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="danger" title="Valider la suppression" @click="ok()">
        Supprimer
      </b-button>
      <b-button
        variant="default"
        title="Annuler la suppression"
        @click="cancel()"
      >
        Annuler
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {BModal, BButton} from "bootstrap-vue-next";

import {useReactiveStoreGetters} from "@/composables/useStore";
import {aerogenerateurService} from "@/service/aerogenerateur.service";
import {ref, watch} from "vue";
import {posteLivraisonService} from "@/service/posteLivraison.service";

// Props
const {poste, addNotification} = defineProps(["poste", "addNotification"]);

// Data
const currentPoste = ref(poste)

// Watch for changes in the prop
watch(() => poste, (newValue) => {
  currentPoste.value = newValue
})

// Methods
const deletePosteLivraison = () => {
  posteLivraisonService
    .deletePosteLivraison(poste.id)
    .then(response => {
      const httpMethod = "DELETE";
      addNotification(response, httpMethod);
    })
    .catch(err => {
      console.log(err);
    });
}

</script>
<style lang="scss">
</style>
